// extracted by mini-css-extract-plugin
export default {"container":"cookies_container__6t5Qb","container_buttons":"cookies_container_buttons__7WZh1","button":"cookies_button__YQw2H","secondaireButton":"cookies_secondaireButton__oinFI"};